import { format } from "date-fns";

import logo from "../asset/img/logo.png";
import { rootUrl } from "../App";
import { isEmpty } from "../utils/helpers";

export const totalPagesExp = "{t}";

export const minReqHeight = 50;

export const createDidDrawPage = (doc, reportName, tenant, date, unit) => {
  var currentPage = 0;
  return HookData => {
    if (currentPage === 0) {
      ///////////////////////
      ////// Header   ///////
      ///////////////////////

      //* Print Logo *//
      let logoWidth = tenant?.logoWidth;
      if (!isEmpty(tenant?.logo)) {
        const filename = tenant.logo;
        const ext = filename.split(".")[1];
        doc.addImage(`${rootUrl}/api/files/${filename}?path=tenant/${tenant.tenantId}`, ext, 7, 5, logoWidth || 15, 15);
        logoWidth = logoWidth + 3;
      }

      //* Print Tenant & Report Name *//
      doc.setFontSize(16);
      doc.text(unit?.displayName || unit?.name || tenant?.name || "", doc.internal.pageSize.getWidth() / 2, 11, "center");
      doc.setFontSize(12);
      doc.text(reportName, doc.internal.pageSize.getWidth() / 2, 18, "center");

      //** Print Jaza Logo */
      doc.addImage(logo, "PNG", doc.internal.pageSize.getWidth() - 21, 3, 14, 13);
      doc.setFontSize(11);
      doc.text("WFX", doc.internal.pageSize.getWidth() - 7, 20, "right");

      //* Draw Line after Header Content *//
      doc.line(7, 22, doc.internal.pageSize.getWidth() - 7, 22);
    }

    ///////////////////////
    ////// Footer   ///////
    ///////////////////////

    doc.setFont("Courier", "");
    doc.setFontSize(10);

    //* Print Page Number *//
    //* Print Date *//
    const today = typeof date === "number" ? new Date(date) : new Date();
    doc.text("Date: " + format(today, "dd-MM-yyyy h:mm a"), 7, doc.internal.pageSize.getHeight() - 7, "left");

    var str = "Page " + doc.internal.getNumberOfPages();
    str = str + " of " + totalPagesExp;
    doc.text(str, doc.internal.pageSize.getWidth() - 3, doc.internal.pageSize.getHeight() - 7, "right");

    doc.setFont("helvetica", "normal");

    currentPage = doc.internal.getNumberOfPages();
  };
};

// Date is Optional
export const setDefault = (doc, reportName, tenant, date, unit) => {
  doc.autoTableSetDefaults({
    theme: "grid",
    margin: { horizontal: 7 },
    tableWidth: "auto",
    showHead: "firstPage",
    styles: { overflow: "linebreak", fontSize: 8, cellPadding: 1.5 },
    // headStyles: { lineWidth: 0.1, lineColor: "#FFFFFF", halign: "center" },
    headStyles: { lineWidth: 0.1, lineColor: "#FFFFFF" },
    didDrawPage: createDidDrawPage(doc, reportName, tenant, date, unit)
  });
};

/**
 * A Thin wrapper over jsPDF.autoTable method for controlling width of column in deterministic way
 *
 * @param {jsPDF} doc - JS PDF doc object
 * @param {Object} autoTableOptions - Auto Table Options
 * @param {Object} options - Custom options for controlling witdh of Columns. {minCharLen: '', maxCharLen: '', tableWidth: '', colWidthMap: {[index]: " "} or {[dataKey]: ''}}
 * @returns void
 */
export const addTable = (doc, autoTableOptions, options = {}) => {
  if (!doc || isEmpty(autoTableOptions)) {
    console.error("[doc, autoTableOptions] args required for adding Table.");
    return;
  }

  const { columns = [], head = [], body = [], columnStyles = {} } = autoTableOptions;
  let columnWidthStyles = getColumnWidthStyles({ columns, head, body, options });

  const finalColumnStyles = Object.keys(columnWidthStyles).reduce(
    (acc, key) => ({ ...acc, [key]: { ...columnStyles[key], ...columnWidthStyles[key] } }),
    {}
  );
  doc.autoTable({ ...autoTableOptions, columnStyles: finalColumnStyles });
};

const getColumnWidthStyles = ({ columns, head, body, options }) => {
  const { tableWidth = 196, minCharLen = 10, maxCharLen = 35, colWidthMap = {} } = options;

  const charLengthMap = getColCharLengthMap(columns, head, body, minCharLen, maxCharLen);
  const totalCharLength = Object.values(charLengthMap).reduce((acc, charLength) => acc + charLength, 0);

  const defaultColWidthMap = Object.keys(charLengthMap).reduce(
    (acc, key) => ({ ...acc, [key]: (charLengthMap[key] * tableWidth) / totalCharLength }),
    {}
  );

  const columnStyles = Object.keys(defaultColWidthMap).reduce(
    (acc, key) => ({ ...acc, [key]: { minCellWidth: colWidthMap[key] || defaultColWidthMap[key] } }),
    {}
  );
  return columnStyles;
};

export const getColCharLengthMap = (columns, head, body, minCharLen, maxCharLen) => {
  if (isEmpty(head)) {
    const charLengthMap = columns.reduce(
      (acc, column) => ({
        ...acc,
        [column.dataKey]: Math.min(
          Math.max(
            [
              ...body.map(row => row[column.dataKey]),
              (column?.header || column?.title)
                ?.split(" ")
                .filter(e => !isEmpty(e))
                .map(e => e.length)
                .sort((a, b) => b - a)[0]
            ]
              .filter(e => !isEmpty(e))
              .map(e => `${e}`.length)
              .sort((a, b) => b - a)[0],
            minCharLen
          ),
          maxCharLen
        )
      }),
      {}
    );
    return charLengthMap;
  } else {
    const headRow = [...head].sort((a, b) => b.length - a.length)[0];
    const finalRows = [headRow, ...body];
    const colCount = headRow?.length;

    const charLengthMap = Array(colCount)
      .fill("")
      .reduce(
        (acc, _, index) => ({
          ...acc,
          [index]: Math.min(
            Math.max(
              finalRows
                .map(rowArray => rowArray[index])
                .filter(e => !isEmpty(e))
                .map(e => `${e}`.length)
                .sort((a, b) => b - a)[0],
              minCharLen
            ),
            maxCharLen
          )
        }),
        {}
      );
    return charLengthMap;
  }
};
